import React from 'react';
import { Form, Typography } from 'antd';
import { DollarOutlined } from '@ant-design/icons';
import { calculPrice, computeReducedPrice } from './index';
import { quoteCustomPrice } from './customPriceRules';
import { t } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";

const { Text } = Typography



export default (formPlugin, namespace) =>
{
    const POSITION_VERTICAL = [
        `Haut`,
        `Milieu`,
        `Bas`
    ]

    const POSITION_HORIZONTAL = [
        `Gauche`,
        `Centre`,
        `Droite`
    ]

    return {
        Renderer: (props) => {

            if (props.remove) {
                formPlugin.onAddFormPlugin(props, props.nodeId, props.pluginConfig.id)
            }

            const { data } = props

            let alignItems = "flex-end"
            let justifyContent = "flex-end"

            switch (data.vertical_position) {
                case POSITION_VERTICAL[0]:
                    alignItems = "flex-start"
                    break;
                case POSITION_VERTICAL[1]:
                    alignItems = "center"
                    break;
                case POSITION_VERTICAL[2]:
                    alignItems = "flex-end"
                    break;
            }

            switch (data.horizontal_position) {
                case POSITION_HORIZONTAL[0]:
                    justifyContent = "flex-start"
                    break;
                case POSITION_HORIZONTAL[1]:
                    justifyContent = "center"
                    break;
                case POSITION_HORIZONTAL[2]:
                    justifyContent = "flex-end"
                    break;
            }

            var style = { display: "flex", alignItems: alignItems, justifyContent: justifyContent }
            var textStyle = {}

            if (data.fontSize) {
                textStyle.fontSize = data.fontSize
            }

            const finalAmount = calculPrice(formPlugin.formValues, formPlugin.formData, formPlugin.org?.devise)
            const formatedAmount = formPlugin.currencyFormat(finalAmount / 100)
            const isAbo=formPlugin.formData?.paiementType==="MONTHLY"

            return (
                <Form.Item shouldUpdate noStyle>
                    {(form)=>
                    {
                        const pricingForm = {...formPlugin.formData, simpleEditor:false, content:formPlugin.savedTree || formPlugin.formData.content}
                        const custom = quoteCustomPrice({form:pricingForm, values:form.getFieldsValue(true), devise:formPlugin.org?.devise, baseDevise:formPlugin.formData?.devise || formPlugin.org?.devise, productPrice:computeReducedPrice})
                        if (custom && Number.isFinite(custom.total)) {
                            return <div style={style} aria-live="polite" aria-atomic="true">
                                <Text style={textStyle}>{data.label || t`Total`} : {formPlugin.currencyFormat(custom.total / 100)}</Text>
                            </div>
                        }
                        const codes = formPlugin.formData?.promotionalCodes || []
                        let inputPromo=form.getFieldValue("__promo")

                        let text=(
                            <>
                                <Trans>{data.label || t`Total`} :</Trans>
                                {finalAmount > 0 ? formatedAmount : 0}
                                {isAbo && (<Trans>/ Mois</Trans>)}
                            </>
                        )

                        if(inputPromo?.length>0){
                            let code=codes.find(i=>i?.promotionalCode===inputPromo)
                            if(code)
                            {
                                let price=finalAmount || 0
                                let reducedPercent=code.reducedPercent || 0
                                let reducedPrice=price-((price/100)*reducedPercent)

                                text=(
                                    <>
                                        <Trans>{data.label || t`Total`} :</Trans>
                                        <span
                                            style={{ textDecorationLine: 'line-through' }}>{formPlugin.currencyFormat(price / 100)} {isAbo && (
                                            <Trans>/ Mois</Trans>)}</span>
                                        <span
                                            style={{ fontWeight: 'bold',marginLeft:10 }}>{formPlugin.currencyFormat(reducedPrice / 100)} {isAbo && (
                                            <Trans>/ Mois</Trans>)}</span>
                                    </>
                                )
                            }
                        }

                        return (
                            <div style={style}>
                            <Text style={textStyle}>
                                    {text}
                                </Text>
                            </div>
                        )
                    }}
                </Form.Item>
            )
        },
        namespace: namespace,
        id: 'form-product-total' + namespace,
        title: t`Total`,
        description: t`Élément de formulaire utilisable.`,
        icon: <DollarOutlined />,
        iconColor: "#8E44AD",
        version: 1,
        hideInMenu: formPlugin.formData.type !== "COMPLEX",
        controls: {
            type: 'autoform',
            schema: {
                properties: {
                    vertical_position: {
                        type: "string",
                        uniforms: {
                            showIf: () => false,
                            label: t`Positionnement Vertical`,
                            allowedValues: POSITION_VERTICAL,
                        }
                    },
                    horizontal_position: {
                        type: "string",
                        uniforms: {
                            label: t`Positionnement Horizontal`,
                            allowedValues: POSITION_HORIZONTAL,
                        }
                    },
                    label: {
                        type: 'string',
                        uniforms: {
                            label: t`Titre`,
                            placeholder: t`Total`,
                        }
                    },
                    fontSize: {
                        type: 'number',
                        uniforms: {
                            label: t`Taille de police`,
                            placeholder: t`pixel`,
                        }
                    },
                }
            },
        },
    }
}
